import { render, staticRenderFns } from "./ChevronDoubleLeftIcon.vue?vue&type=template&id=08e8bbda&scoped=true"
import script from "./ChevronDoubleLeftIcon.vue?vue&type=script&lang=js"
export * from "./ChevronDoubleLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8bbda",
  null
  
)

export default component.exports